(function() {
    'use strict';
    angular
        .module('sgnmrApp')
        .factory('OrganoRelevanteNorma', OrganoRelevanteNorma);

    OrganoRelevanteNorma.$inject = ['$resource'];

    function OrganoRelevanteNorma ($resource) {
        var resourceUrl =  'api/organo-relevantes/norma/:id';

        return $resource(resourceUrl, {}, {
            
            'get': {
                method: 'GET', isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();
